import React, { useEffect } from "react";
import TooltipWrapper from "./../../../shared/items/contols/tooltipWrapper";

import { getCarsTypeName } from "./static.carsTypes";
import CarsCheckbox from "../../../shared/items/contols/carCheckbox";

import getDates from "../../../shared/services/date.service";

import styles from "./carsListReportItem.module.scss";
import KeyIcon from "@mui/icons-material/Key";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import GasMeterIcon from "@mui/icons-material/GasMeter";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import SettingsInputComponentIcon from "@mui/icons-material/SettingsInputComponent";
import ScatterPlotIcon from "@mui/icons-material/ScatterPlot";
import DeviceThermostatIcon from "@mui/icons-material/DeviceThermostat";
import AddRoadIcon from "@mui/icons-material/AddRoad";
import DeviceHubIcon from "@mui/icons-material/DeviceHub";

const FUELE1 = "FUELE1";
const FUELE2 = "FUELE2";
const FUELE3 = "FUELE3";
const FUEF = "FUEF";
const FUEAMO = "FUEAMO";
const DU1 = "DU1";
const DU2 = "DU2";
const SAND = "SAND";
const QUI = "QUI";
const TE = "TE";
const DISSE = "DISSE";
const FUALLS = "FUALLS";

const muiIconStyle = {
  width: "18px",
};

const CarsListReportItem = (props) => {
  const { data, checked, changeReportCar, changeActiveInfoCar, selected, handleScrollTo } = props;

  const getStatusStyles = () => {
    switch (data.unit.inActive ? "inActive" : getCarsTypeName(data.status.id)) {
      case "noData":
        return styles.container_carNumber_noData;
      case "inMove":
        return styles.container_carNumber_inMove;
      case "parking":
        return styles.container_carNumber_parking;
      case "inActive":
        return styles.container_carNumber_inActive;
      default:
        return styles.container_carNumber_inActive;
    }
  };

  useEffect(() => {
    if (selected) {
      handleScrollTo(document.querySelectorAll(`.selected_container_carsListItemWrapper`)[0].offsetTop);
    }
  }, [selected]);

  const isCanSensor = Object.keys(data.sensors).some((x) => {
    return x.includes("CAN");
  });

  return (
    <div className={styles.reportCarsListItem}>
      <div className={styles.container_carsListItem}>
        <div className={selected ? styles.carsListItemSelectedWrapper : styles.carsListItemWrapper}>
          <div className={styles.container_carsListItemWrapper}>
            <div className={styles.carsListItem} onClick={changeActiveInfoCar}>
              <TooltipWrapper title={data.status.title} position="right">
                <div className={getStatusStyles()}>
                  <span className={styles.title}>{data.number}</span>
                </div>
              </TooltipWrapper>

              <div className={styles.carsListItemInner}>
                <div className={styles.container_carContent}>
                  <div className={styles.container_name}>
                    <div>{data.unit.title}</div>

                    <div className={styles.dashboardPanelContainer}>
                      <div>{data.unit.registerNumber}</div>

                      <div className={styles.dashboardPanel}>
                        {!data.gpsSignal ? (
                          <TooltipWrapper title={"Ошибка данных GPS"} position="top">
                            <div className={styles.dashboardPanelItem}>
                              <WarningAmberIcon style={{ ...muiIconStyle, color: "#ff626c" }} />
                            </div>
                          </TooltipWrapper>
                        ) : null}

                        {isCanSensor ? (
                          <TooltipWrapper title={"CAN-шина"} position="top">
                            <div className={styles.dashboardPanelItem}>
                              <DeviceHubIcon style={muiIconStyle} />
                            </div>
                          </TooltipWrapper>
                        ) : null}

                        {data.sensors[DISSE] !== undefined ? (
                          <TooltipWrapper title={data.sensors[DISSE]} position="top">
                            <div className={styles.dashboardPanelItem}>
                              <AddRoadIcon style={muiIconStyle} />
                            </div>
                          </TooltipWrapper>
                        ) : null}

                        {data.sensors[TE] !== undefined ? (
                          <TooltipWrapper title={data.sensors[TE]} position="top">
                            <div className={styles.dashboardPanelItem}>
                              <DeviceThermostatIcon style={muiIconStyle} />
                            </div>
                          </TooltipWrapper>
                        ) : null}

                        {data.sensors[SAND] !== undefined ? (
                          <TooltipWrapper title={data.sensors[SAND]} position="top">
                            <div className={styles.dashboardPanelItem}>
                              <ScatterPlotIcon style={muiIconStyle} />
                            </div>
                          </TooltipWrapper>
                        ) : null}

                        {data.sensors[DU1] !== undefined ? (
                          <TooltipWrapper title={data.sensors[DU1]} position="top">
                            <div className={styles.dashboardPanelItem}>
                              <AcUnitIcon style={muiIconStyle} />
                            </div>
                          </TooltipWrapper>
                        ) : null}

                        {data.sensors[DU2] !== undefined ? (
                          <TooltipWrapper title={data.sensors[DU2]} position="top">
                            <div className={styles.dashboardPanelItem}>
                              <AcUnitIcon style={muiIconStyle} />
                            </div>
                          </TooltipWrapper>
                        ) : null}

                        {data.sensors[FUEF] !== undefined ? (
                          <TooltipWrapper title={data.sensors[FUEF]} position="top">
                            <div className={styles.dashboardPanelItem}>
                              <GasMeterIcon style={muiIconStyle} />
                            </div>
                          </TooltipWrapper>
                        ) : null}

                        {data.sensors[FUALLS] !== undefined ? (
                          <TooltipWrapper title={data.sensors[FUALLS]} position="top">
                            <div className={styles.dashboardPanelItem}>
                              <GasMeterIcon style={muiIconStyle} />
                            </div>
                          </TooltipWrapper>
                        ) : null}

                        {data.sensors[FUEAMO] !== undefined ? (
                          <TooltipWrapper title={data.sensors[FUEAMO]} position="top">
                            <div className={styles.dashboardPanelItem}>
                              <GasMeterIcon style={muiIconStyle} />
                            </div>
                          </TooltipWrapper>
                        ) : null}

                        {data.sensors[QUI] !== undefined ? (
                          <TooltipWrapper title={data.sensors[QUI]} position="top">
                            <div className={styles.dashboardPanelItem}>
                              <SettingsInputComponentIcon style={muiIconStyle} />
                            </div>
                          </TooltipWrapper>
                        ) : null}

                        {data.sensors[FUELE1] !== undefined ? (
                          <TooltipWrapper title={data.sensors[FUELE1]} position="top">
                            <div className={styles.dashboardPanelItem}>
                              <LocalGasStationIcon style={muiIconStyle} />
                            </div>
                          </TooltipWrapper>
                        ) : null}

                        {data.sensors[FUELE2] !== undefined ? (
                          <TooltipWrapper title={data.sensors[FUELE2]} position="top">
                            <div className={styles.dashboardPanelItem}>
                              <LocalGasStationIcon style={muiIconStyle} />
                            </div>
                          </TooltipWrapper>
                        ) : null}

                        {data.sensors[FUELE3] !== undefined ? (
                          <TooltipWrapper title={data.sensors[FUELE3]} position="top">
                            <div className={styles.dashboardPanelItem}>
                              <LocalGasStationIcon style={muiIconStyle} />
                            </div>
                          </TooltipWrapper>
                        ) : null}

                        <TooltipWrapper title={data.ignition ? "Зажигание включено" : "Зажигание выключено"} position="top">
                          <div className={styles.dashboardPanelItem}>
                            {data.ignition ? <KeyIcon style={{ ...muiIconStyle, color: "#f7bf47" }} /> : <KeyIcon style={muiIconStyle} />}
                          </div>
                        </TooltipWrapper>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {selected ? (
            <div className={getStatusStyles(data.status.id)}>
              <div className={styles.mDCarItem}>
                <span className={styles.mDCarItemTitle}>IMEI</span>
                <span className={styles.mDCarItemContent}>{data.devices[0].imei}</span>
              </div>

              {data.drivers.length > 0 ? (
                <div className={styles.mDCarItem}>
                  <span className={styles.mDCarItemContent}>Водитель (-и):</span>

                  {data.drivers.map((driver) => {
                    return (
                      <div>
                        <span className={styles.mDCarItemTitle}>
                          {driver.lastName} {driver.firstName} {driver.middleName}
                        </span>
                      </div>
                    );
                  })}
                </div>
              ) : null}

              <div className={styles.mDCarItem}>
                <span className={styles.mDCarItemTitle}>Последняя активность</span>
                <span className={styles.mDCarItemContent}>{getDates.getDateFormat4(data.lastActive)}</span>
              </div>
              <div className={styles.mDCarItem}>
                <span className={styles.mDCarItemTitle}>Группы</span>
                <span className={styles.mDCarItemContent}>
                  {data.unit.groups.map((item) => (
                    <div key={item.id}>{item.title}</div>
                  ))}
                </span>
              </div>
            </div>
          ) : null}
        </div>
      </div>

      <div className={styles.container_chooseReportCar}>
        <CarsCheckbox checked={checked} changeReportCar={changeReportCar} />
      </div>
    </div>
  );
};

export default React.memo(CarsListReportItem);
